export default "__VITE_ASSET__DNzxxi9I__"